// extracted by mini-css-extract-plugin
module.exports = {"navSocialLink":"_DeOt","facebook":"_25MMG","twitter":"_208PD"};